// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  background: #1e1e1e;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  border: 1px solid #333333;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.card:hover {
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  transform: translateY(-2px);
  border-color: #00ff88;
}

.card-header {
  padding: 1.5rem 1.5rem 0;
  border-bottom: 1px solid #333333;
  margin-bottom: 1.5rem;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.5rem 0;
  line-height: 1.2;
}

.card-subtitle {
  font-size: 1rem;
  color: #cccccc;
  margin: 0;
  line-height: 1.5;
}

.card-content {
  padding: 0 1.5rem 1.5rem;
}

/* Auth card specific styles */
.card.auth-card {
  max-width: 28rem;
  width: 100%;
  margin: 0 auto;
}

.card.auth-card .card-header {
  text-align: center;
  padding: 2rem 1.5rem 0;
}

.card.auth-card .card-title {
  font-size: 1.75rem;
  margin-bottom: 0.75rem;
}

.card.auth-card .card-content {
  padding: 0 1.5rem 2rem;
}

/* Responsive */
@media (max-width: 640px) {
  .card {
    border-radius: 0.75rem;
    margin: 0 1rem;
  }
  
  .card-header {
    padding: 1.25rem 1.25rem 0;
  }
  
  .card-content {
    padding: 0 1.25rem 1.25rem;
  }
  
  .card.auth-card {
    margin: 0 1rem;
    max-width: none;
  }
  
  .card.auth-card .card-header {
    padding: 1.5rem 1.25rem 0;
  }
  
  .card.auth-card .card-content {
    padding: 0 1.25rem 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/Card.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".card {\n  background: #1e1e1e;\n  border-radius: 1rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);\n  border: 1px solid #333333;\n  overflow: hidden;\n  transition: all 0.3s ease-in-out;\n}\n\n.card:hover {\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);\n  transform: translateY(-2px);\n  border-color: #00ff88;\n}\n\n.card-header {\n  padding: 1.5rem 1.5rem 0;\n  border-bottom: 1px solid #333333;\n  margin-bottom: 1.5rem;\n}\n\n.card-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 0.5rem 0;\n  line-height: 1.2;\n}\n\n.card-subtitle {\n  font-size: 1rem;\n  color: #cccccc;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.card-content {\n  padding: 0 1.5rem 1.5rem;\n}\n\n/* Auth card specific styles */\n.card.auth-card {\n  max-width: 28rem;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.card.auth-card .card-header {\n  text-align: center;\n  padding: 2rem 1.5rem 0;\n}\n\n.card.auth-card .card-title {\n  font-size: 1.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.card.auth-card .card-content {\n  padding: 0 1.5rem 2rem;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .card {\n    border-radius: 0.75rem;\n    margin: 0 1rem;\n  }\n  \n  .card-header {\n    padding: 1.25rem 1.25rem 0;\n  }\n  \n  .card-content {\n    padding: 0 1.25rem 1.25rem;\n  }\n  \n  .card.auth-card {\n    margin: 0 1rem;\n    max-width: none;\n  }\n  \n  .card.auth-card .card-header {\n    padding: 1.5rem 1.25rem 0;\n  }\n  \n  .card.auth-card .card-content {\n    padding: 0 1.25rem 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
